import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, parseCategories, getImageUrl } from "../utils/helpers";
import { InlineShareButtons } from "./ShareButton";

const NewsSection = ({
  topNews,
  trendingNews,
  headings,
  lang,
  imageVersion,
}) => {
  const navigate = useNavigate();

  const handleCardKeyPress = (e, slug) => {
    if (e.key === "Enter" || e.key === " ") {
      navigate(`/news/${slug}`);
    }
  };

  return (
    <div className="container mx-auto px-4 py-4 grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2">
        <h2 className="text-2xl font-bold mb-4 border-b-2 border-red-600 pb-2 ">
          {headings.topNews}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {topNews.map((news) => (
            <div
              key={news.id}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => handleCardKeyPress(e, news.slug)}
              onClick={() => navigate(`/news/${news.slug}`)}
              className="bg-white rounded-lg shadow-md overflow-hidden transform hover:-translate-y-1 transition-transform duration-300 relative cursor-pointer"
            >
              <div className="relative">
                <img
                  src={
                    news.image && news.image.length > 0
                      ? `${news.image[0]}?v=${imageVersion}`
                      : getImageUrl(
                          news,
                          (() => {
                            const categories = parseCategories(news.categories);
                            return categories.length > 0
                              ? categories[0]
                              : "News";
                          })(),
                          imageVersion
                        )
                  }
                  alt={news.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4">
                  <div className="mb-2 flex flex-wrap gap-2">
                    {(parseCategories(news.categories) || []).map((c, idx) => (
                      <span
                        key={idx}
                        className="text-xs font-semibold text-red-600 bg-red-100 px-2 py-0.5 rounded-full capitalize"
                      >
                        {c}
                      </span>
                    ))}
                  </div>
                  <h3
                  style={{color: '#215077'}}
                    className="font-bold text-lg mb-2 h-14 overflow-hidden"
                  >
                    {news.title}
                  </h3>
                  <div className="text-sm text-gray-500 flex justify-between items-center mt-4">
                    <span>{formatDate(news.createdAt)}</span>
                    <InlineShareButtons
                      url={`${window.location.origin}/news/${news.slug}`}
                      title={news.title}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h2 className="text-2xl font-bold mb-4 border-b-2 border-red-600 pb-2">
          {headings.trending}
        </h2>
        <div className="space-y-4">
          {trendingNews.map((news) => (
            <div
              key={news.id}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => handleCardKeyPress(e, news.slug)}
              onClick={() => navigate(`/news/${news.slug}`)}
              className="relative rounded-lg cursor-pointer p-2 hover:bg-gray-100 transition-colors flex items-start space-x-4"
            >
              <div className="w-24 h-16 flex-shrink-0 relative">
                <img
                  src={
                    news.image && news.image.length > 0
                      ? `${news.image[0]}?v=${imageVersion}`
                      : getImageUrl(news, "Trending", imageVersion)
                  }
                  alt={news.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="mb-1 flex flex-wrap gap-1">
                  {(parseCategories(news.categories) || []).map((c, idx) => (
                    <span
                      key={idx}
                      className="text-[10px] font-semibold text-red-600 bg-red-100 px-2 py-0.5 rounded-full capitalize"
                    >
                      {c}
                    </span>
                  ))}
                </div>
                <h4 className="font-semibold leading-tight line-clamp-2 break-words" style={{ overflowWrap: "anywhere" }}>
                  {news.title}
                </h4>
                <div className="flex items-center justify-between mt-1">
                  <p className="text-xs text-gray-500">
                    {formatDate(news.createdAt)}
                  </p>
                  <InlineShareButtons
                    url={`${window.location.origin}/news/${news.slug}`}
                    title={news.title}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
